import React from 'react';
import { Helmet } from 'react-helmet-async';

function Merchandise() {
  return (
    <div className="container">
      <Helmet>
        <title>Merchandise & Products | Bunny Boutique 321</title>
        <meta name="description" content="Checkout our latest brand merchandise as well as our recommended Amazon products that make for great starter kits." />
        <link rel="canonical" href="https://bunnyboutique321.com/merchandise" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Merchandise & Products | Bunny Boutique 321" />
        <meta property="og:description" content="Checkout our latest brand merchandise as well as our recommended Amazon products that make for great starter kits." />
        <meta property="og:url" content="https://bunnyboutique321.com/merchandise" />
        <meta property="og:image" content="https://bunnyboutique321.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Merchandise & Products | Bunny Boutique 321" />
        <meta name="twitter:description" content="Checkout our latest brand merchandise as well as our recommended Amazon products that make for great starter kits." />
        <meta name="twitter:image" content="https://bunnyboutique321.com/og-image.jpg" />
      </Helmet>
      <span className="eyebrow">Shop the Boutique</span>
      <h1>Boutique & Supplies</h1>
      <p className="section-subtitle">
        Carefully selected products for your new bunny, along with our custom handcrafted items.
      </p>

      {/* --- ETSY SECTION --- */}
      <section style={{ marginBottom: '60px' }}>
        <h2 style={{ borderBottom: '2px solid #e3bac4', paddingBottom: '10px', color: '#e3bac4', marginBottom: '30px', fontSize: '1.17em', textAlign: 'inherit' }}>
          Handcrafted on Etsy
        </h2>
        <div className="grid-layout">

          {/* Custom Etsy Link Card */}
          <div className="bunny-card">
            <div className="card-image-container">
              {/* Replace the URL below with a photo of your actual Etsy products */}
              <img src="https://i.etsystatic.com/52975872/r/il/43801f/8561768894/il_794xN.8561768894_1bw2.jpg" loading="lazy" decoding="async" alt="Bunny Boutique Weekender Bag - Navy" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <h3>Bunny Boutique Custom Merch</h3>
            <p>Browse our full collection of handcrafted bunny accessories, toys, and apparel.</p>

            {/* Replace the href link with your actual Etsy shop link */}
            <a href="https://www.etsy.com/listing/4580403307/bunny-boutique-weekender-bag-navy" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="reserve-btn" style={{ marginTop: '15px' }}>
                Shop on Etsy
              </button>
            </a>
          </div>

          {/* Custom Etsy Link Card */}
          <div className="bunny-card">
            <div className="card-image-container">
              {/* Replace the URL below with a photo of your actual Etsy products */}
              <img src="https://i.etsystatic.com/52975872/r/il/4cd8d8/8609667875/il_794xN.8609667875_d9r6.jpg" loading="lazy" decoding="async" alt="Bunny Boutique Weekender Bag - White" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <h3>Bunny Boutique Custom Merch</h3>
            <p>Browse our full collection of handcrafted bunny accessories, toys, and apparel.</p>

            {/* Replace the href link with your actual Etsy shop link */}
            <a href="https://www.etsy.com/listing/4580422894/bunny-boutique-weekender-bag-white" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="reserve-btn" style={{ marginTop: '15px' }}>
                Shop on Etsy
              </button>
            </a>
          </div>

          {/* Custom Etsy Link Card */}
          <div className="bunny-card">
            <div className="card-image-container">
              {/* Replace the URL below with a photo of your actual Etsy products */}
              <img src="https://i.etsystatic.com/52975872/r/il/2828d4/8609784431/il_794xN.8609784431_9x40.jpg" loading="lazy" decoding="async" alt="Bunny Boutique 321 Classic T-Shirt" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <h3>Bunny Boutique Custom Merch</h3>
            <p>Browse our full collection of handcrafted bunny accessories, toys, and apparel.</p>

            {/* Replace the href link with your actual Etsy shop link */}
            <a href="https://www.etsy.com/listing/1746062459/bunny-boutique-321-classic-t-shirts" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="reserve-btn" style={{ marginTop: '15px' }}>
                Shop on Etsy
              </button>
            </a>
          </div>

        </div>
      </section>

      {/* --- AMAZON AFFILIATE SECTION --- */}
      <section>
        <h2 style={{ borderBottom: '2px solid #07162c', paddingBottom: '10px', color: '#07162c', marginBottom: '30px', fontSize: '1.17em', textAlign: 'inherit' }}>
          Recommended Supplies
        </h2>
        <div className="grid-layout">

          {/* Amazon Product Card 1 */}
          <div className="bunny-card">
            <div className="card-image-container">
              {/* Replace with a picture of the product */}
              <img src="https://m.media-amazon.com/images/I/61rXeRaCFgL._AC_SL1500_.jpg" loading="lazy" decoding="async" alt="Bunny Castle" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <h3>Bunny Castle</h3>
            <p>Your Bunny''s perfect space for ruling their own little world from home.</p>

            {/* Replace the href with your Amazon Affiliate Link */}
            <a href="https://amzn.to/3Qi9gT6" target="_blank" rel="sponsored nofollow noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="reserve-btn" style={{ marginTop: '15px', backgroundColor: '#07162c', color: '#ffffff' }}>
                View on Amazon
              </button>
            </a>
          </div>

          {/* Amazon Product Card 2 */}
          <div className="bunny-card">
             <div className="card-image-container">
               {/* Replace with a picture of the product */}
               <img src="https://m.media-amazon.com/images/I/81aaIbOUviL._AC_SL1500_.jpg" loading="lazy" decoding="async" alt="Timothy Hay" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
             </div>
            <h3>Premium Timothy Hay</h3>
            <p>The gold standard for daily nutrition. Keeps digestion healthy and teeth filed.</p>

            {/* Replace the href with your Amazon Affiliate Link */}
            <a href="https://amzn.to/4tZoH0Y" target="_blank" rel="sponsored nofollow noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="reserve-btn" style={{ marginTop: '15px', backgroundColor: '#07162c', color: '#ffffff' }}>
                View on Amazon
              </button>
            </a>
          </div>

          {/* Amazon Product Card 3 */}
          <div className="bunny-card">
             <div className="card-image-container">
               {/* Replace with a picture of the product */}
               <img src="https://m.media-amazon.com/images/I/81MDrvVMPhL._AC_SL1500_.jpg" loading="lazy" decoding="async" alt="Premium Timothy Hay" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
             </div>
            <h3>Premium Timothy Hay</h3>
            <p>The gold standard for daily nutrition. Keeps digestion healthy and teeth filed.</p>

            {/* Replace the href with your Amazon Affiliate Link */}
            <a href="https://amzn.to/492XMcr" target="_blank" rel="sponsored nofollow noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="reserve-btn" style={{ marginTop: '15px', backgroundColor: '#07162c', color: '#ffffff' }}>
                View on Amazon
              </button>
            </a>
          </div>

          {/* Amazon Product Card 4 */}
          <div className="bunny-card">
             <div className="card-image-container">
               {/* Replace with a picture of the product */}
               <img src="https://m.media-amazon.com/images/I/71EkScqDBnL._AC_SL1500_.jpg" loading="lazy" decoding="async" alt="Indoor Bunny Hutch" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
             </div>
            <h3>Indoor Bunny Hutch</h3>
            <p>A unique indoor space for your bunnies to enjoy.</p>

            {/* Replace the href with your Amazon Affiliate Link */}
            <a href="https://amzn.to/42jIBYE" target="_blank" rel="sponsored nofollow noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="reserve-btn" style={{ marginTop: '15px', backgroundColor: '#07162c', color: '#ffffff' }}>
                View on Amazon
              </button>
            </a>
          </div>

          {/* Amazon Product Card 5 */}
          <div className="bunny-card">
             <div className="card-image-container">
               {/* Replace with a picture of the product */}
               <img src="https://m.media-amazon.com/images/I/61CWFMC6uNL._AC_SL1500_.jpg" loading="lazy" decoding="async" alt="8pc Stacking Cups" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
             </div>
            <h3>8pc Stacking Cups</h3>
            <p>Great toys for hiding food and playing.</p>

            {/* Replace the href with your Amazon Affiliate Link */}
            <a href="https://amzn.to/4vNdySI" target="_blank" rel="sponsored nofollow noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="reserve-btn" style={{ marginTop: '15px', backgroundColor: '#07162c', color: '#ffffff' }}>
                View on Amazon
              </button>
            </a>
          </div>

          {/* Amazon Product Card 6 */}
          <div className="bunny-card">
             <div className="card-image-container">
               {/* Replace with a picture of the product */}
               <img src="https://m.media-amazon.com/images/I/61aaK6d0e3L._AC_SL1500_.jpg" loading="lazy" decoding="async" alt="Large Bunny Litter Box" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
             </div>
            <h3>Large Bunny Litter Box</h3>
            <p>Litter box for your bunny''s bathroom needs</p>

            {/* Replace the href with your Amazon Affiliate Link */}
            <a href="https://amzn.to/4sQPU54" target="_blank" rel="sponsored nofollow noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="reserve-btn" style={{ marginTop: '15px', backgroundColor: '#07162c', color: '#ffffff' }}>
                View on Amazon
              </button>
            </a>
          </div>

          {/* Amazon Product Card 7 */}
          <div className="bunny-card">
             <div className="card-image-container">
               {/* Replace with a picture of the product */}
               <img src="https://m.media-amazon.com/images/I/51NLVf7jj1L._AC_SL1024_.jpg" loading="lazy" decoding="async" alt="Bunny Hideout Castle" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
             </div>
            <h3>Bunny Hideout Castle</h3>
            <p>A fun little place for your bunny to play and sleep.</p>

            {/* Replace the href with your Amazon Affiliate Link */}
            <a href="https://amzn.to/4mJjTKO" target="_blank" rel="sponsored nofollow noopener noreferrer" style={{ textDecoration: 'none' }}>
              <button className="reserve-btn" style={{ marginTop: '15px', backgroundColor: '#07162c', color: '#ffffff' }}>
                View on Amazon
              </button>
            </a>
          </div>

        </div>
      </section>
    </div>
  );
}

export default Merchandise;